import { Box, CssBaseline, Grid } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import PageMainTitle from 'components/cmn/PageMainTitle';
import AccountManageTable from 'components/member-management/AccountManageTable';
import UserSearch from 'components/member-management/AccountSearch';
import { memo } from 'react';

function MemberManagementPage(): JSX.Element {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title="회원관리" />
          <UserSearch />
          <CustomCard sx={{ mt: 2 }} content={false} border>
            <AccountManageTable />
          </CustomCard>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(MemberManagementPage);
